// Guard de rol para rutas. El ocultamiento en el launcher es solo cosmético:
// sin esto, un alumno que escribe /app/teacher en la URL entra igual (el backend
// devuelve 403, pero la UI no lo redirige ni avisa). Esto cierra ese gap.
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore, type AuthUser } from "@/lib/auth-store";

type Role = AuthUser["role"];

export function RequireRole({
  allow,
  children,
}: {
  allow: Role[];
  children: ReactNode;
}) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.accessToken);

  // Sin sesión → al login (el AppLayout también lo cubre, pero por si se monta directo).
  if (!token) return <Navigate to="/login" replace />;

  if (!user || !allow.includes(user.role)) {
    // No autorizado: lo mandamos a la biblioteca (su home) en vez de pantalla rota.
    return <Navigate to="/app/cases" replace />;
  }

  return <>{children}</>;
}

export const TEACHER_ROLES: Role[] = ["teacher", "institution_admin", "platform_admin"];
export const ADMIN_ROLES: Role[] = ["institution_admin", "platform_admin"];
